import { InterventionScopeNameEnum, TaskScopeNameEnum } from 'graphql-common';
import { CustomTaskScopeNameEnum } from 'constants/enums';
import { DocumentTabEnum } from 'routes/Documents/enums';

// `tab` is read from the *current* page's URL via `useTabParam()`. When a
// scan action navigates to a different list (e.g. user on /documentation
// scans "Find tasks"), that foreign tab value would land in the destination
// URL and the destination page would build a malformed `scope` variable.
// Validate against the destination's scope enum before forwarding; fall
// back to the destination's default tab otherwise.

const TASK_TAB_VALUES: ReadonlySet<string> = new Set([
  ...Object.values(TaskScopeNameEnum),
  ...Object.values(CustomTaskScopeNameEnum),
]);

const INTERVENTION_TAB_VALUES: ReadonlySet<string> = new Set(
  Object.values(InterventionScopeNameEnum),
);

const DOCUMENTATION_TAB_VALUES: ReadonlySet<string> = new Set(
  Object.values(DocumentTabEnum),
);

export const isValidTaskTab = (t: unknown): t is string =>
  typeof t === 'string' && TASK_TAB_VALUES.has(t);

export const isValidInterventionTab = (t: unknown): t is string =>
  typeof t === 'string' && INTERVENTION_TAB_VALUES.has(t);

export const isValidDocumentationTab = (t: unknown): t is string =>
  typeof t === 'string' && DOCUMENTATION_TAB_VALUES.has(t);
